import React from 'react';

interface IconLabelProps {
    /** Glyphicon name without the prefix, e.g. "info-sign" */
    icon: string;
    text: React.ReactNode;
    /** Hide the text below the breakpoint, leaving only the icon */
    collapse?: boolean;
    className?: string;
}

export const IconLabel = ({ icon, text, collapse = false, className }: IconLabelProps) => {
    const classes = ['icon-label', className].filter(Boolean).join(' ');
    const textClasses = collapse ? 'icon-label__text icon-label__text--collapse' : 'icon-label__text';

    return (
        <span className={classes} title={collapse && typeof text === 'string' ? text : undefined}>
            <span className={`glyphicon glyphicon-${icon}`} aria-hidden="true" />
            <span className={textClasses}>{text}</span>
        </span>
    );
};
